// extracted by mini-css-extract-plugin
export default {"languageContainer":"ChangeLanguage_languageContainer__4DmMJ","languageItem":"ChangeLanguage_languageItem__XRb5A","selectedLanguage":"ChangeLanguage_selectedLanguage__pB4N0"};